import { trendData, sourcesData, topPages, geoData, realtimeVisitors } from '@/mocks/home';

const kpis = [
  { label: '今日访问量', value: '32,840', delta: '+18.2%', icon: 'ri-eye-line', up: true },
  { label: '独立访客', value: '8,216', delta: '+12.6%', icon: 'ri-user-3-line', up: true },
  { label: '独立 IP', value: '6,943', delta: '+9.4%', icon: 'ri-global-line', up: true },
  { label: '平均停留', value: '4m 32s', delta: '-2.1%', icon: 'ri-time-line', up: false },
];

function TrendChart() {
  const max = Math.max(...trendData.map((d) => d.value));
  return (
    <div className="flex items-end justify-between gap-2 h-40">
      {trendData.map((d) => (
        <div key={d.label} className="flex-1 flex flex-col items-center gap-2">
          <div
            className="w-full rounded-t-md bg-gradient-to-t from-primary-500 to-accent-400 transition-all hover:from-primary-600 hover:to-accent-500"
            style={{ height: `${(d.value / max) * 100}%` }}
          />
          <span className="text-[10px] text-foreground-500 whitespace-nowrap">{d.label}</span>
        </div>
      ))}
    </div>
  );
}

export default function DashboardPreview() {
  return (
    <section id="dashboard" className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50">
      <div className="mx-auto max-w-7xl">
        <div className="text-center max-w-2xl mx-auto">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-900 text-xs font-semibold">
            数据看板
          </span>
          <h2 className="mt-4 font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            一个后台，看清所有关键数据
          </h2>
          <p className="mt-4 text-foreground-600 leading-relaxed">
            从访问总量到实时访客，从来源渠道到地域分布，所有数据一目了然，无需任何技术门槛。
          </p>
        </div>

        <div className="mt-12 rounded-lg border border-background-200 bg-background-50 overflow-hidden">
          <div className="flex items-center gap-2 px-5 py-3 border-b border-background-200 bg-background-100">
            <span className="w-3 h-3 rounded-full bg-primary-400" />
            <span className="w-3 h-3 rounded-full bg-secondary-400" />
            <span className="w-3 h-3 rounded-full bg-accent-400" />
            <span className="ml-3 text-xs text-foreground-500">app.statflow.io/dashboard</span>
          </div>

          <div className="p-5 md:p-8">
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
              {kpis.map((k) => (
                <div
                  key={k.label}
                  className="rounded-lg border border-background-200 bg-background-50 p-4"
                >
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-foreground-500">{k.label}</span>
                    <span className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-100 text-primary-700">
                      <i className={`${k.icon} text-sm`} />
                    </span>
                  </div>
                  <div className="mt-3 font-heading text-2xl font-bold text-foreground-950">
                    {k.value}
                  </div>
                  <div
                    className={`mt-1 text-xs font-semibold ${
                      k.up ? 'text-accent-700' : 'text-primary-700'
                    }`}
                  >
                    {k.delta} 较昨日
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-6 grid grid-cols-1 lg:grid-cols-3 gap-4">
              <div className="lg:col-span-2 rounded-lg border border-background-200 p-5">
                <div className="flex items-center justify-between">
                  <h4 className="text-sm font-semibold text-foreground-900">近 7 日访问趋势</h4>
                  <span className="text-xs text-foreground-500">PV / 日</span>
                </div>
                <div className="mt-6">
                  <TrendChart />
                </div>
              </div>

              <div className="rounded-lg border border-background-200 p-5">
                <h4 className="text-sm font-semibold text-foreground-900">来源渠道</h4>
                <div className="mt-5 flex flex-col gap-4">
                  {sourcesData.map((s) => (
                    <div key={s.label}>
                      <div className="flex items-center justify-between text-xs">
                        <span className="text-foreground-700">{s.label}</span>
                        <span className="font-semibold text-foreground-900">{s.value}%</span>
                      </div>
                      <div className="mt-1.5 h-2 rounded-full bg-background-100 overflow-hidden">
                        <div
                          className={`h-full rounded-full ${s.color}`}
                          style={{ width: `${s.value}%` }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="mt-6 grid grid-cols-1 lg:grid-cols-3 gap-4">
              <div className="lg:col-span-2 rounded-lg border border-background-200 p-5">
                <h4 className="text-sm font-semibold text-foreground-900">热门页面 TOP 4</h4>
                <div className="mt-4 flex flex-col divide-y divide-background-100">
                  {topPages.map((p, i) => (
                    <div key={p.title} className="flex items-center justify-between py-3">
                      <div className="flex items-center gap-3 min-w-0">
                        <span className="w-6 h-6 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-900 text-xs font-bold">
                          {i + 1}
                        </span>
                        <span className="text-sm text-foreground-800 truncate">{p.title}</span>
                      </div>
                      <div className="text-right">
                        <div className="text-sm font-semibold text-foreground-900">
                          {p.views.toLocaleString()}
                        </div>
                        <div className="text-[10px] text-foreground-500">{p.rate} 停留</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="rounded-lg border border-background-200 p-5">
                <h4 className="text-sm font-semibold text-foreground-900">地域分布</h4>
                <div className="mt-4 flex flex-col gap-2.5">
                  {geoData.map((g) => (
                    <div key={g.region} className="flex items-center gap-3">
                      <span className="w-10 text-xs text-foreground-600 whitespace-nowrap">
                        {g.region}
                      </span>
                      <div className="flex-1 h-2 rounded-full bg-background-100 overflow-hidden">
                        <div
                          className="h-full rounded-full bg-accent-500"
                          style={{ width: `${g.value}%` }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="mt-6 rounded-lg border border-background-200 p-5">
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse" />
                <h4 className="text-sm font-semibold text-foreground-900">实时访客</h4>
                <span className="text-xs text-foreground-500">当前在线 128 人</span>
              </div>
              <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-3">
                {realtimeVisitors.map((v) => (
                  <div
                    key={v.ip}
                    className="flex items-center gap-3 rounded-md bg-background-100 px-4 py-3"
                  >
                    <span className="w-8 h-8 flex items-center justify-center rounded-md bg-background-50 border border-background-200 text-foreground-600">
                      <i className={`${v.device} text-sm`} />
                    </span>
                    <div className="min-w-0 flex-1">
                      <div className="text-sm font-medium text-foreground-900">{v.ip}</div>
                      <div className="text-xs text-foreground-500 truncate">
                        {v.region} · {v.page}
                      </div>
                    </div>
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{v.time}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}